declare namespace $ {

	export class $mol_icon_fullscreen extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=fullscreen.view.tree.d.ts.map